import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import AssetSystem from 'src/systems/AssetSystem';
import ProjectSystem from 'src/systems/ProjectSystem';

import Asset from '../../models/asset';
import Folder from '../../models/folder';
import { useApi } from '../../../../providers/ApiProvider';
import { downloadAssetsPresenterFactoryFor } from './utils';

type DownloadItemsParams = {
	assets: Asset[];
	folders: Folder[];
	withRoundNumber?: boolean;
	lowRes?: boolean;
	unpreviewable?: boolean;
}

type UseReduxDownloadItemsParams = {
	shareRef?: string;
	onDownloadFinish?: () => void;
}

const useReduxDownloadMultipleItems = ( { shareRef, onDownloadFinish }: UseReduxDownloadItemsParams ) => {
	const dispatch = useDispatch();
	const api = useApi();
	const snackbarSystem = useSnackbarSystem();
	const assetSystem = new AssetSystem( dispatch );
	const projectSystem = new ProjectSystem( { api } );

	return useCallback( ( {
		assets, folders, withRoundNumber, lowRes, unpreviewable
	}: DownloadItemsParams ) => {
		const factory = downloadAssetsPresenterFactoryFor( shareRef );

		const presenter = factory.forDownloadAssets( {
			assets,
			folders,
			lowRes,
			withRoundNumber,
			projectSystem,
			assetSystem,
			snackbarSystem,
			onFinish: onDownloadFinish,
			unpreviewable
		} );

		presenter.trigger();
	}, [ onDownloadFinish, assetSystem, snackbarSystem, projectSystem, shareRef ] );
}

export default useReduxDownloadMultipleItems;
